import { render, staticRenderFns } from "./NewsSchoolParent.vue?vue&type=template&id=6ab151cd&scoped=true"
import script from "./NewsSchoolParent.vue?vue&type=script&lang=js"
export * from "./NewsSchoolParent.vue?vue&type=script&lang=js"
import style0 from "./NewsSchoolParent.vue?vue&type=style&index=0&id=6ab151cd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab151cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab151cd')) {
      api.createRecord('6ab151cd', component.options)
    } else {
      api.reload('6ab151cd', component.options)
    }
    module.hot.accept("./NewsSchoolParent.vue?vue&type=template&id=6ab151cd&scoped=true", function () {
      api.rerender('6ab151cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/parent/NewsSchoolParent.vue"
export default component.exports